"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _semanticUiReact = require("semantic-ui-react");

var _default = function _default(_ref) {
  var slug = _ref.slug,
      pageTitle = _ref.pageTitle,
      internal = _ref.internal,
      linksAs = _ref.linksAs,
      onToggle = _ref.onToggle,
      centerMobileNavItems = _ref.centerMobileNavItems,
      linkComponent = _ref.linkComponent;
  return _react["default"].createElement(_semanticUiReact.Container, (0, _extends2["default"])({
    as: internal ? linkComponent : 'a',
    onClick: function onClick() {
      return onToggle();
    },
    style: {
      textAlign: centerMobileNavItems ? 'center' : 'left',
      margin: '1.25em 1em 0 1em',
      display: 'block'
    },
    activeStyle: {
      textDecoration: 'bold'
    }
  }, internal ? {
    to: slug
  } : {
    href: slug
  }, internal ? {
    target: '_top'
  } : {
    target: '_blank',
    onClick: function onClick() {
      _reactGa["default"].event({
        category: 'Outbound Link',
        action: 'Click',
        label: pageTitle
      });
    }
  }), linksAs === 'text' ? _react["default"].createElement("span", null, pageTitle) : _react["default"].createElement(_semanticUiReact.Header, {
    as: linksAs
  }, pageTitle));
};

exports["default"] = _default;